export const SCOPE_PREFIX = '@components';

export const ErrorsSeverity = {
	UNEXPECTED_ERROR: 'UnexpectedError',
	WARNING: 'Warning',
	VALIDATION_ERROR: 'ValidationError',
};
